import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { Link } from 'react-router';
import { FormattedMessage } from 'component-utilities/intl';

import { SecondaryButton } from '../Buttons/Components';

import styles from './ManagementList.scss';

function ManagementListButton(props) {
    return (<div className={styles['ml-button']}>
        <Link to={props.path}>
            <SecondaryButton
                data-action={`manage-${props.name}`}
                extraClassName={styles['button-secondary']}
                onClick={props.onClick}
            >
                <FormattedMessage id="components.buttons.manage" />
            </SecondaryButton>
        </Link>
    </div>)
}

ManagementListButton.displayName = displayName('ManagementList/ManagementListButton');

ManagementListButton.propTypes = {
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ManagementListButton;
